import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_OBJECTS: createActionType(FULL_NAMESPACE, "GET_OBJECTS"),
    GET_OBJECTS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_OBJECTS_COMPLETED"),
    GET_OBJECTS_REJECTED: createActionType(FULL_NAMESPACE, "GET_OBJECTS_REJECTED"),
    GET_METHODS: createActionType(FULL_NAMESPACE, "GET_METHODS"),
    GET_METHODS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_METHODS_COMPLETED"),
    GET_METHODS_REJECTED: createActionType(FULL_NAMESPACE, "GET_METHODS_REJECTED")
};
